import DCF_ACTIONS from '../constants/dcf-action-codes';

/* To check non-std dcfActionCode or error event receives from partner DCF for checkout api
* @param {string} dcfActionCode
* @param {boolean} isCardFirst
* @return {boolean}
*/

const isCustomDcfErrorEvent = (dcfActionCode, isCardFirst) => {
  const { CANCEL, SERVER_ERROR, SERVICE_ERROR, UNKNOWN_ERROR } = DCF_ACTIONS;
  return (
    dcfActionCode === undefined ||
    (dcfActionCode === SERVICE_ERROR && !isCardFirst) ||
    dcfActionCode === UNKNOWN_ERROR ||
    dcfActionCode === SERVER_ERROR ||
    dcfActionCode === CANCEL
  );
};

export default isCustomDcfErrorEvent;
